import { createSlice } from '@reduxjs/toolkit';

const LPSlice = createSlice({
  name: 'LP',
  initialState: {
    product: {
      id: '',
      productID: '', // Initially, no user is logged in 
      proName: '',
      quantity: '',
      subtotal: '',
      total:'',
      name: '',
      number: '',
      size: '',
      price: '',
      image: '',
    },
  },
  reducers: {
    setLPID: (state, action) => {
      // state.product.LPID = action.payload;
      const item = action.payload;
      state.product.id = item.id;
      state.product.productID = item.productID;
      state.product.image = item.image;
      state.product.proName = item.proName;
      state.product.quantity = item.quantity;
      state.product.price = item.price;
      state.product.name = item.name;
      state.product.number = item.number;
      state.product.size = item.size;
      state.product.subtotal = item.subtotal;
      state.product.total = item.total;

    },
    clearLPID: (state) => {
      state.product = {}; // Clear the user ID when the user logs out
    },
  },
});

export const { setLPID, clearLPID } = LPSlice.actions;
export default LPSlice.reducer;
